import {AuthHeader} from "./auth.token";

export const AxiosConfig = () => ({
	headers: {
		Authorization : AuthHeader(),
	}
});
